import request from '@/utils/request'

// 查询我的设计的商品sku列表
export function listSku(query) {
  return request({
    url: '/server/designSku/list',
    method: 'get',
    params: query
  })
}

// 查询我的设计的商品sku详细
export function getSku(skuId) {
  return request({
    url: '/server/designSku/' + skuId,
    method: 'get'
  })
}

// 通过商品id查询所有商品sku
export function getDesignSku(designId) {
  return request({
    url: '/server/designSku/skuList/' + designId,
    method: 'get'
  })
}

// 新增我的设计的商品sku
export function addSku(data) {
  return request({
    url: '/server/designSku',
    method: 'post',
    data: data
  })
}

// 修改我的设计的商品sku
export function updateSku(data) {
  return request({
    url: '/server/designSku',
    method: 'put',
    data: data
  })
}

// 删除我的设计的商品sku
export function delSku(skuId) {
  return request({
    url: '/server/designSku/' + skuId,
    method: 'delete'
  })
}

// 导出我的设计的商品sku
export function exportSku(query) {
  return request({
    url: '/server/designSku/export',
    method: 'get',
    params: query
  })
}